/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves Operation Approvals list
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationssigned
*/
export const SAVE_OPERATION_APPROVALS_LIST = (state, { pageNumber, data }) => {
    if (data.list) {
        state.operationApprovalsList = pageNumber === 1 ? data.list : state.operationApprovalsList.concat(data.list)

        state.approvalsHasMore = data.hasMore
        state.totalNumberOfOperationsToSign = data.totalNumberOfOperationsToSign
    } else {
        state.operationApprovalsList = data

        state.approvalsHasMore = null
        state.totalNumberOfOperationsToSign = null
    }
}

/** saves accounts with operations pending signature
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationssignedaccounts
*/
export const SAVE_ACCOUNTS_WITH_OPERATIONS_PENDING_SIGNATURE = (state, payload) => {
    state.accountsWithOperationsPendingSignature = payload.accounts
}
